import { render, staticRenderFns } from "./FeedCard.vue?vue&type=template&id=69a10a9c&scoped=true&"
import script from "./FeedCard.vue?vue&type=script&lang=js&"
export * from "./FeedCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedCard.vue?vue&type=style&index=0&id=69a10a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a10a9c",
  null
  
)

export default component.exports